import * as constants from './constants'
import * as apiHelper from '../../../apiHelper'

import { setUserLoggedOut, pushError, popError, pushSuccess } from '../../global/actions';
import { dismissNotification } from '../inbox/actions';

const controller = 'bookings';

const onBookingResponse = (json, dispatch, onSuccessMessage) => {
  if (json.error) {
    dispatch(pushError({
      errType: 'bookingerror',
      message: json.error.message ? json.error.message : 'An unknown server error occurred in creating your booking request.'
    }))
    return;
  } else if (json.auth === false) {
    dispatch(setUserLoggedOut());
    return;
  }
  if (json.booking) {
    dispatch(setBookingInfo(json.booking));
    dispatch(pushSuccess(onSuccessMessage))
  }
}

export function createBookingRequest(bookingRequest) {
  return (dispatch, getState) => {
    let state = getState();
    dispatch(popError('bookingerror'));
    return apiHelper.apiPost(controller, bookingRequest, state.Global.token)
      .then(response => response.json())
      .then(json => {
        onBookingResponse(json, dispatch, "Booking Requested");
      })
  }
}

export function getBookingPricing(cb) {
  return (dispatch, getState) => {
    let state = getState();

    return apiHelper.apiPost(controller, state.Booking.selectedBooking, state.Global.token, null, ['pricing'])
      .then(response => response.json())
      .then(json => (json.auth === false)
        ? dispatch(setUserLoggedOut())
        : dispatch(setBookingInfo(json.booking)))
  }
}

export function getEstimatedBookingPrice(listingId, startDate, endDate) {
  const payload = {
    listingId,
    startDate,
    endDate,
    guests: 1,
    hasPets: false,
    selectedAddOns: []
  }
  return (dispatch, getState) => {
    let state = getState();

    return apiHelper.apiPost(controller, payload, state.Global.token, null, ['pricing'])
      .then(response => response.json())
      .then(json => {
        return json;
      }).catch(error => {
        throw error;
      })
  }
}

export function getBookings() {
  return (dispatch, getState) => {
    let state = getState();
    getRenterBookings(dispatch, state.Global.token);
    getListingBookings(state.Global.userId, dispatch, state.Global.token);
    return {};
  }
}

function getRenterBookings(dispatch, token) {
  return apiHelper.apiGet(controller, token)
    .then(response => response.json())
    .then(json => dispatch(setBookingsList(json.bookings)))
}

function getListingBookings(userId, dispatch, token) {
  return apiHelper.apiGet("listing", token, "owner", [userId, "bookings"])
    .then(response => response.json())
    .then(json => dispatch(setListingBookingsList(json.bookings)))
}

export function getBooking(bookingId) {
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiGet(controller, state.Global.token, bookingId)
      .then(response => response.json())
      .then(json => dispatch(setBookingInfo(json.booking)))
  }
}

export function getAndReplaceBooking(bookingId) {
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiGet(controller, state.Global.token, bookingId)
      .then(response => response.json())
      .then(json => {
        if (state.Global.userId === json.booking.userId._id) {
          dispatch(setBookingsListReplaceOne(json.booking))
        } else {
          dispatch(setListingBookingsListReplaceOne(json.booking))
        }
      })
  }
}

export function cancelBooking(bookingId) {
  return (dispatch, getState) => {
    let state = getState();
    dispatch(popError('bookingerror'));
    return apiHelper.apiPost(controller, {}, state.Global.token, bookingId, "cancel")
      .then(response => response.json())
      .then(json => {
        onBookingResponse(json, dispatch, "Booking Cancelled");
      })
  }
}

export function chargeBooking(bookingId) {
  return (dispatch, getState) => {
    let state = getState();
    dispatch(popError('bookingerror'));
    return apiHelper.apiPost(controller, {}, state.Global.token, bookingId, "charge")
      .then(response => response.json())
      .then(json => {
        onBookingResponse(json, dispatch, "Booking Accepted");
      })
  }
}

export function acceptBooking(booking, notification) {
  return (dispatch) => {
    booking.bookingRequestStatus = 'Accepted';
    dispatch(updateBooking(booking, notification));
  }
}

export function rejectBooking(booking, notification) {
  return (dispatch) => {
    booking.bookingRequestStatus = 'Rejected';
    dispatch(updateBooking(booking, notification));
  }
}

export function updateBooking(booking, notificationToDismiss) {
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiPut(controller, booking, state.Global.token, booking._id)
      .then(response => response.json())
      .then(json => dispatch(setBookingsListReplaceOne(json.booking)))
      .then(() => { if (notificationToDismiss) dispatch(dismissNotification(notificationToDismiss)) })
  }
}

export function setBookingsList(bookings) {
  return {
    type: constants.SET_BOOKINGS_LIST,
    data: bookings
  }
}

export function setListingBookingsList(bookings) {
  return {
    type: constants.SET_LISTINGBOOKINGS_LIST,
    data: bookings
  }
}

export function setBookingInfo(booking) {
  return {
    type: constants.SET_SELECTED_BOOKING,
    data: booking
  }
}

export function setBookingsListReplaceOne(booking) {
  return {
    type: constants.SET_BOOKINGS_REPLACEONE,
    data: booking
  }
}

export function setListingBookingsListReplaceOne(booking) {
  return {
    type: constants.SET_LISTINGBOOKINGS_REPLACEONE,
    data: booking
  }
}
